import React from 'react'

import wtdLogo from 'brands/buffalo/assets/img/lenders/brp.svg'
import usePortalCopy from 'hooks/usePortalCopy'
import usePortalJump from 'hooks/usePortalJump'
import ApplicationPortal from 'state/enums/ApplicationPortal'

import {
    Banner,
    CtaButton,
    Description,
    Logo,
    TextSection,
} from './ApprovalOemPortalJumpCta.styled'

interface ApprovalOemPortalJumpCtaProps {
    readonly applicationUuid: string
}

export default function ApprovalOemPortalJumpCta({
    applicationUuid,
}: ApprovalOemPortalJumpCtaProps): React.ReactElement {
    const { hasCopy, isLoading, triggerCopy } = usePortalCopy(
        applicationUuid,
        ApplicationPortal.BUFFALO,
    )

    const handleClick = usePortalJump(hasCopy, triggerCopy)

    return (
        <Banner>
            <Logo src={wtdLogo} alt="BRP Financial Services" />
            <TextSection>
                <Description>
                    Check for applicable BRP Finance Offers and Promos
                </Description>
            </TextSection>
            <CtaButton
                variant="primaryOutlined"
                disabled={isLoading}
                onClick={handleClick}
            >
                {hasCopy ? 'Open Application' : 'View BRP Offers & Promos'}
            </CtaButton>
        </Banner>
    )
}
